import { Bar, BarChart, CartesianGrid, LabelList, XAxis, YAxis } from "recharts"
import { Card, CardContent, } from "./Card"
import { ChartContainer, ChartTooltip, ChartTooltipContent } from "./Chart"
import { useLanguage } from "../context/LanguageProvider";

export default function BaarChartConfirmator({ data }) {
  const { t } = useLanguage();
  const chartData = (data || []).map((item) => ({
    name: item.name,
    orders: item.confirmed_orders,
  }))

  const chartConfig = {
    orders: {
      label: t('charts.confirmed_orders'),
      color: "#fff",
    },
    label: {
      color: "#fff",
    },
  }

  return (
    <Card className="shadow-none border-none m-0 p-0 ">
      <CardContent className="px-6">
        <ChartContainer config={chartConfig} className="h-44 w-64">
          <BarChart
            accessibilityLayer
            data={chartData}
            margin={{ top: 16, right: 16, left: 0, bottom: 0 }}
          >
            <CartesianGrid stroke="#aaaaaa50" strokeDasharray="3 3" />
            <XAxis
              dataKey="name"
              tickLine={false}
              tickMargin={10}
              axisLine={false}
              fontSize={10}
            />
            <YAxis width={30} fontSize={10} />
            <ChartTooltip
              cursor={{ fill: "rgba(0,0,0,0.05)" }}
              content={<ChartTooltipContent className="relative bg-white text-gray-600 border border-slate-200 shadow-lg  
                before:absolute before:left-2.5 before:top-[5px] before:bottom-0 
                before:w-1 before:h-8 before:rounded-xl before:bg-[var(--color-primary-500)] before:content-['']" indicator="line" />}
            />
            <Bar
              dataKey="orders"
              fill="var(--color-primary-500)"
              radius={4}
              
            >
              <LabelList
                dataKey="orders"
                position="top"
                className="fill-foreground"
                fontSize={9}
                formatter={(val) => (val === 0 ? "" : val)}
              />
            </Bar>
          </BarChart>
        </ChartContainer>
      </CardContent>
    </Card>
  )
}
